export default "__VITE_ASSET__1271ffd6__"